/**
 * Created by dongxingbin on 17/7/28.
 */

const base = ''
// const base = '/api'

export const login = base + '/adminUser/login';

// 根据id查询后台用户信息
export const getAdminUserById = base + '/adminUser/getUserInfoById';

// 更新后台用户密码
export const updateAdminUserPassword = base + '/adminUser/updatePassword';

// 分页查询后台用户
export const getAdminUserByPage = base + '/adminUser/listByPage';

// 新增后台用户
export const addNewAdminUser = base + '/adminUser/addNewAdmin';

// 更新后台用户信息
export const updateAdminUserById = base + '/adminUser/updateById';

// 重置后台用户密码
export const resetPasswordByAdminUserId = base + '/adminUser/resetPasswordByUserId';

// 删除后台用户
export const deleteAdminUserById = base + '/adminUser/deleteById';

// 新增用户
export const addNewUser = base + '/user/add';

// 更新用户
export const updateUserById = base + '/user/updateById';

// 删除用户
export const deleteUserById = base + '/user/deleteById';

// 重置用户密码
export const resetUserPassword = base + '/user/resetUserPassword';

// 根据id查询字典
export const querySysDictById = base + '/sysDict/queryById';

// 根据code查询字典
export const getSysDictByCode = base + '/sysDict/getByCode';

// 更新字典
export const updateSysDictById = base + '/sysDict/updateById';

////////////////////////////////////////////////  传感器  ///////////////////////////////////////////////////////

// 分页查询传感器
export const querySensorByPage = base + '/sensor/querySensorByPage';

// 查询所有传感器
export const querySensorAll = base + '/sensor/querySensorAll';

// 查询传感器详情
export const querySensorById = base + '/sensor/queryById';

// 新增传感器
export const saveSensor = base + '/sensor/save';

// 更新传感器
export const updateSensorById = base + '/sensor/updateById';

// 删除传感器
export const deleteSensorById = base + '/sensor/deleteById';

// 查询传感器状态详情
export const querySensorDetailBySensorId = base + '/sensorDetail/queryBySensorId';

//////////////////////////////////////////////////  任务  /////////////////////////////////////////////////////

// 分页查询任务
export const queryTaskByPage = base + '/task/queryTaskByPage';

// 查询任务详情
export const queryTaskById = base + '/task/queryById';

// 新增任务
export const saveTask = base + '/task/save';

// 更新任务
export const updateTaskById = base + '/task/updateById';

// 删除任务
export const deleteTaskById = base + '/task/deleteById';

//////////////////////////////////////////////////  子任务  /////////////////////////////////////////////////////

// 分页查询子任务
export const queryTaskSubByPage = base + '/taskSub/queryTaskSubByPage';

// 查询子任务详情
export const queryTaskSubById = base + '/taskSubr/queryById';

// 新增子任务
export const saveTaskSub = base + '/taskSub/save';

// 更新子任务
export const updateTaskSubById = base + '/taskSub/updateById';

// 删除子任务
export const deleteTaskSubById = base + '/taskSub/deleteById';

// 分页查询定时任务队列
export const queryScheduleTaskByPage = base + '/picScheduleTask/queryScheduleTaskByPage';

// 更新定时任务队列
export const updateScheduleTaskById = base + '/picScheduleTask/updateById';

//////////////////////////////////////////////////  图片采集管理  /////////////////////////////////////////////////////

// 分页查询采集的图片列表
export const queryPicCollectByPage = base + '/picCollect/queryPicCollectByPage';

// 根据id批量删除数据（逻辑删除）
export const batchDeletePicCollByIds = base + '/picCollect/batchDeleteByIds';

// 特殊导入图片
export const specialImportPic = base + '/picCollect/specialImportPicApi';

// 更新图片信息
export const updatePicById = base + '/picCollect/updateById';

// 导出子任务下的全景图像、损伤图片、参数结果
export const exportPanoramaAnalysisParameters = base + '/picCollect/exportPanoramaAnalysisParameters';

// 图片转换
export const convertPic = base + '/picCollect/convertPic';

// 测线合并
export const mixPic = base + '/picCollect/mixPic';

// 根据id查询分析详情
export const queryPicCollectById = base + '/picCollect/queryById';

//////////////////////////////////////////////////  操作传感器  /////////////////////////////////////////////////////

// 查询传感器在线状态
export const querySensorOnlineStatus = base + '/picCollect/querySensorOnlineStatus';

// 初始化传感器状态
export const initSensorStatus = base + '/sensorDetail/initSensorStatus';

// 查询传感器距离、角度、陀螺仪各状态
export const querySensorStatus = base + '/sensorDetail/querySensorStatus';

// 控制传感器（马达、灯光、测距仪）
export const operateSensor = base + '/picCollect/operateSensor';

// 单次采集图像
export const collectPic = base + '/picCollect/collect';

// 自动采集图像
export const autoCollectPic = base + '/picCollect/autoCollect';

// 查询传感器测距与陀螺仪状态
export const querySensorDistanceAndGyro = base + '/picCollect/querySensorDistanceAndGyro';

// 开启传感器摄像服务
export const openCamera = base + '/sensorDetail/openCamera';

// 关闭传感器摄像服务
export const stopCamera = base + '/sensorDetail/stopCamera';

//////////////////////////////////////////////////  损伤分析  /////////////////////////////////////////////////////

// 获取图像分析默认参数
export const getDefaultAnalysisParams = base + '/picAnalysis/getDefaultAnalysisParams';

// 异步批量分析图像
export const asyncBatchAnalysisPic = base + '/picAnalysis/asyncBatchAnalysisPic';

// 异步批量分析图像（一键分析）
export const asyncBatchAnalysisPicNew = base + '/picAnalysis/asyncBatchAnalysisPicNew';

// 分页查询损伤分析结果列表
export const queryPicAnalysisByPage = base + '/picAnalysis/queryPicAnalysisByPage';

// 删除损伤分析结果
export const deletePicAnalysis = base + '/picAnalysis/deleteById';

// 查询损伤分析来源图
export const getPicAnalysisSource = base + '/picAnalysisSource/queryById';

// 分页查询图片分析项
export const queryPicAnalysisItemByPage = base + '/picAnalysisItem/queryPicAnalysisItemByPage';

// 录入二值化图
export const recordBinaryImage = base + '/picAnalysisItem/recordBinaryImage';

// 根据二值化图计算损伤参数
export const calcMarByBinaryImage = base + '/picAnalysisItem/calcMarByBinaryImage';

// 批量下载分析项图片
export const downloadPicAnalysisItems = base + '/picAnalysisItem/downloadPicAnalysisItems';

// 自动二值化分析
export const autoCreateBinaryImage = base + '/picAnalysisItem/autoCreateBinaryImage';

// 自动计算参数
export const autoCalcParams = base + '/picAnalysisItem/autoCalcParams';

// 更新损伤分析结果
export const updatePicAnalysis = base + '/picAnalysis/updateById';

// 根据id查询分析详情
export const queryPicAnalysisById = base + '/picAnalysis/queryById';

// 正式图像分析
export const analysisPicByFormal = base + '/picAnalysis/analysisPicByFormal';

// 切图图像分析
export const analysisPicByCut = base + '/picAnalysis/analysisPicByCut';

// 保存分析结果
export const analysisPicBySave = base + '/picAnalysis/analysisPicBySave';

//////////////////////////////////////////////////  三维重建  /////////////////////////////////////////////////////

// 新增三维重建任务
export const savePicRebuild = base + '/picRebuild/save';

// 更新三维重建任务
export const updatePicRebuild = base + '/picRebuild/updateById';

// 设置三维重建结果
export const setRebuildResult = base + '/picRebuild/setRebuildResult';

// 分页查询三维重建
export const queryPicRebuildByPage = base + '/picRebuild/queryPicRebuildByPage';

// 删除三维重建结果
export const deletePicRebuild = base + '/picRebuild/deleteById';

// 三维重建
export const rebuildPic = base + '/picRebuild/rebuildPic';

// 三维重建（视频）
export const rebuildByVideo = base + '/picRebuild/rebuildPicByVideo';

// 分页查询三维重建源
export const queryPicRebuildSourceByPage = base + '/picRebuildSource/queryPicRebuildSourceByPage';

//////////////////////////////////////////////////  模型设置  /////////////////////////////////////////////////////

// 处理文件夹下的所有图片 - 异步批量
export const imageHandleByFolder = base + '/imageHandle/dealByFolder';

// 打开本地指定的文件夹
export const openWinLocalFolder = base + '/imageHandle/openWinLocalFolder';

//////////////////////////////////////////////////  全景图像、摄像机标定  /////////////////////////////////////////////////////

// 生成全景图像
export const generatePanoramaView = base + '/picCollect/generatePanoramaView';

// 摄像机标定
export const generateCameraSetImage = base + '/picCollect/generateCameraSetImage';

//////////////////////////////////////////////////  通用任务  /////////////////////////////////////////////////////

// 分页查询通用任务
export const queryCommonTaskByPage = base + '/commonTask/queryCommonTaskByPage';

// 查询通用任务详情
export const queryCommonTaskById = base + '/commonTask/queryById';

// 新增通用任务
export const saveCommonTask = base + '/commonTask/save';

// 修改通用任务
export const updateCommonTaskById = base + '/commonTask/updateById';

// 删除通用任务
export const deleteCommonTaskById = base + '/commonTask/deleteById';

//////////////////////////////////////////////////  通用资源  /////////////////////////////////////////////////////

// 分页查询通用资源
export const queryResourceByPage = base + '/resource/queryResourceByPage';

// 查询通用资源详情
export const queryResourceById = base + '/resource/queryById';

// 新增通用资源
export const saveResource = base + '/resource/save';

// 修改通用资源
export const updateResourceById = base + '/resource/updateById';

// 删除通用资源
export const deleteResourceById = base + '/resource/deleteById';

//////////////////////////////////////////////////  分析模型及网络训练  /////////////////////////////////////////////////////

// 分页查询分析模型
export const queryAnalysisModelByPage = base + '/analysisModel/queryAnalysisModelByPage';

// 查询分析模型详情
export const queryAnalysisModelById = base + '/analysisModel/queryById';

// 新增分析模型
export const saveAnalysisModel = base + '/analysisModel/save';

// 修改分析模型
export const updateAnalysisModelById = base + '/analysisModel/updateById';

// 删除分析模型
export const deleteAnalysisModelById = base + '/analysisModel/deleteById';

// 查询可用模型
export const getAvailableModels = base + '/analysisModel/getAvailableModels';

/////////////////////////////////////////////////////////////////////////////

// 预训练
export const preNetTrain = base + '/analysisModelTrain/preNetTrain';

// 开始训练
export const startTrain = base + '/analysisModelTrain/startTrain';

// 查询训练日志、损失函数、平均精度（训练中）
export const queryNetTrainByScheduleTask = base + '/analysisModelTrain/queryNetTrainByScheduleTask';

// 查询训练日志、损失函数、平均精度（训练结束）
export const queryTrainLog = base + '/analysisModelTrain/queryTrainLog';

//////////////////////////////////////////////////  视频录像  /////////////////////////////////////////////////////

// 查询传感器是否有正在录制的进程
export const getProcessKeyBySensorId = base + '/media/getProcessKeyBySensorId';

// 开始录像
export const videoBeginRecord = base + '/media/beginRecord';

// 结束录像
export const videoEndRecord = base + '/media/endRecord';

// 强制结束录像
export const forceVideoEndRecord = base + '/media/forceEndRecord';

//////////////////////////////////////////////////  订单  /////////////////////////////////////////////////////

// 分页查询订单
export const queryOrderByPage = base + '/handOrder/queryByPage';

// 查询订单详情
export const queryOrderById = base + '/handOrder/queryDetailById';

// 订单退款
export const refundOrderById = base + '/handOrder/refundOrderById';

// 下载图片
export const downloadOrderPic = base + '/handOrder/downloadOrderPic';

// 刷新订单
export const refreshOrderById = base + '/handOrder/refreshOrderById';

// 设置退款申请状态
export const setRefundApplyStatus = base + '/handOrder/setRefundApplyStatus';

// 设置流程状态
export const setProcessStatus = base + '/handOrder/setProcessStatus';

// 发送订单短信
export const sendOrderSms = base + '/handOrder/sendOrderSms';

// 导出订单Excel
export const exportOrderExcel = base + '/handOrder/exportOrderExcel';

//////////////////////////////////////////////////  上大屏配置  /////////////////////////////////////////////////////

// 分页查询上大屏文字
export const queryHandTextByPage = base + '/handText/queryByPage';

// 新增编辑上大屏文字
export const addOrUpdateHandText = base + '/handText/addOrUpdate';

// 切换上大屏文字状态
export const updateHandTextStatus = base + '/handText/updateStatus';

// 分页查询上大屏时间
export const queryHandTimeByPage = base + '/handTime/queryByPage';

// 新增编辑上大屏时间
export const addOrUpdateHandTime = base + '/handTime/addOrUpdate';

// 切换上大屏时间状态
export const updateHandTimeStatus = base + '/handTime/updateStatus';

// 批量更改时间状态
export const batchUpdateStatus = base + '/handTime/batchUpdateStatus';

// 分页查询上大屏日期
export const queryHandDateByPage = base + '/handDate/queryByPage';

// 新增编辑上大屏日期
export const addOrUpdateHandDate = base + '/handDate/addOrUpdate';

// 切换上大屏日期状态
export const updateHandDateStatus = base + '/handDate/updateStatus';

// 批量更改日期状态
export const batchUpdateDateStatus = base + '/handDate/batchUpdateStatus';

// 查询上大屏配置
export const queryHandDictDetail = base + '/handDict/queryDetail';

// 保存上大屏配置
export const saveHandDictDetail = base + '/handDict/saveDetail';
































///////////////////////////////// 测试使用 ///////////////////////////////////

export const userList = base + '/user/list';

export const userListpage = base + '/user/listpage';

export const userRemove = base + '/user/remove';

export const userBatchremove = base + '/user/batchremove';

export const userEdit = base + '/user/edit';

export const userAdd = base + '/user/add';

//category
export const categoryList = base + '/category/list';

export const categoryListpage = base + '/category/listpage';

export const categoryRemove = base + '/category/remove';

export const categoryBatchremove = base + '/category/batchremove';

export const categoryEdit = base + '/category/edit';

export const categoryAdd = base + '/category/add';

//maintain
export const maintainList = base + '/maintain/list';

export const maintainListpage = base + '/maintain/listpage';
// export const maintainListpage = base + '/MaintainService.svc/GetMaintainItems';

export const maintainRemove = base + '/maintain/remove';

export const maintainBatchremove = base + '/maintain/batchremove';

export const maintainEdit = base + '/maintain/edit';

export const maintainAdd = base + '/maintain/add';

//plan
export const planList = base + '/plan/list';

export const planListpage = base + '/plan/listpage';

export const planRemove = base + '/plan/remove';

export const planBatchremove = base + '/plan/batchremove';

export const planEdit = base + '/plan/edit';

export const planAdd = base + '/plan/add';



// WEBPACK FOOTER //
// ./src/api/urlConfig.js